<template>

    <div id="dashboard">
        <img class="picture" src="../assets/pictures/BNZN.png" alt="" />
       <div class="textLogo">
        智能仓储管理系统
       </div>
       <el-button style=";position: fixed;font-size:18px;color: #ffffff;top:2%;left:97%" @click="home" type="text">首页</el-button> 
    
        <div class="fixed-text">
            <el-button style=" font-size: 24px;margin-left: 70px;" type="text"><p class="glowing-text">库区总览</p> </el-button> 
            <el-button  @click="WarehouseManagement()"  style="font-size: 22px; margin-left: 70px;color: #5f5d5d;" type="text">库房管理 </el-button>
            <el-button  @click="IntelligentWarehousingVisualization()" style="font-size: 22px; margin-left: 70px;color: #5f5d5d;" type="text">货架管理 </el-button> 
        </div>
       
        <Card  style="  top: 30%; right: 10px;  height: 400px;width: 50px;position: fixed;">
                     <!-- 卡片内容放在这里 -->
          <div style="position: fixed;  top: 33%;" >
            <p style="font-size:15px;color: #0efad3;">上一页</p>
            <p style="color: #f3f3f3;">区域1</p>
            <p style="color: #f3f3f3;">区域2</p>
            <p style="color: #f3f3f3;">区域3</p>
            <p style="color: #f3f3f3;">区域4</p>
            <p style="color: #f3f3f3;">区域5</p>
            <p style="color: #f3f3f3;">区域6</p>
            <p style="color: #f3f3f3;">区域7</p>
            <p style="color: #f3f3f3;">区域8</p>
            <p style="color: #f3f3f3;">区域9</p>
            <p style="color: #f3f3f3;">区域10</p>
            <p style="font-size:15px;color: #0efad3;">下一页</p>
            <p style="font-size:5px;color: #35a18f;">第10页</p>
           
          </div>
                       
        </Card>
    </div>
    
    </template>
    <script>
        import Card from './One.vue'; // 导入Card组件
        import * as echarts from 'echarts'
        import './macarons.js'
        export default 
        {
          components: 
          {
            Card, // 注册Card组件
          },
          created () 
          {
      
            
          },
          mounted() 
          {
           this.$nextTick(function ()
            {
              this.ChartOne();
              this.ChartTwo();
            });
            
          },
          methods:
          { home(){
          this.$router.push("/common")
        },
             ChartOne()
            {
             const myChart = echarts.init(this.$refs.chartOne)
               let dataAxis = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
              // prettier-ignore
              let data = [   90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
              let yMax = 500;
              let dataShadow = [];
              for (let i = 0; i < data.length; i++) {
                dataShadow.push(yMax);
              }
    
                        const option = {
                title: {
                
                },
                xAxis: {
                  data: dataAxis,
                  axisLabel: {
                    color: '#fff'
                  },
                  axisLine: {
          show: true, // 显示 x 轴坐标轴线
          lineStyle: {
            color: '#fff' // x 轴坐标轴线颜色
          }
        },
                  z: 444
                },
                yAxis: {
                  axisLabel: {
                    color: '#fff'
                  },splitLine: {
                  show: false // 禁用 x 轴分隔线
                   },
                },
                axisLine: {
          show: true, // 显示 y 轴坐标轴线
          lineStyle: {
            color: '#fff' // y 轴坐标轴线颜色
          }
        },
                dataZoom: [
                  {
                    type: 'inside'
                  }
                ],
                series: [
                  {
                    type: 'bar',
                   
                    itemStyle: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#FFFFF7' },
                        { offset: 0.7, color: '#6EF0DA' },
                        { offset: 1, color: '#33FFCC' }
                      ])
                    },
                    emphasis: {
                      itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          { offset: 0, color: '#70F4DD' },
                          { offset: 0.7, color: '#6EF0DA' },
                          { offset: 1, color: '#33FFCC' }
                        ])
                      }
                    },
                    data: data
                  }
                ]
              };
    
              myChart.setOption(option);
    
            },
            ChartTwo(){
              const myChart = echarts.init(this.$refs.chartTwo)
              const  option = {
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: [820, 932, 901, 934, 1290, 1330, 1320],
          type: 'line',
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(33, 37, 37, 0.1)' },   // 渐变起始颜色
              { offset: 1, color: 'rgba(10, 252, 211,0.8)' }    // 渐变结束颜色
            ])
          }
        }
      ]
    };
    
              myChart.setOption(option);
    
    
            },
            IntelligentWarehousingVisualization(){
              // window.open('http://120.46.209.88:3455/#/ChartComponent', '_blank')
              window.open(`${this.$qian}IntelligentWarehousingVisualization`, '_blank')
            },
            WarehouseManagement(){
              // window.open('http://120.46.209.88:3455/#/WarehouseManagement', '_blank')
              window.open(`${this.$qian}IntelligentWarehousingVisualization`, '_blank')
            },
    
          },
    
        };
    </script>
    <style scoped>
     .ring {
                width: 105px;
                height: 105px;
                border: 30px solid transparent; /* 外圆 */
                border-top-color: rgb(40, 240, 206); /* 环的颜色 */
                border-radius: 100%;
                animation: spin 0.6s linear infinite; /* 环旋转动画 */
            }
    
    @keyframes spin {
                1% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
    
    #dashboard {
      /* 添加样式以定义你的布局和组件的样式 */
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #264a6e;
      position: relative; /* 为了使固定元素相对于父容器定位 */
      height: 100vh; /* 使父容器占据整个视口高度 */
      background: linear-gradient(to bottom, #e0e0e0, #525252); /* 添加渐变背景颜色 */
    }
    
      .fixed-text {
      position: fixed; /* 使用固定定位 */
      top: 0.0%; /* 与顶部的距离 */
      right: 100px;
      color: #fff; /* 文字颜色 */
      font-size: 15px; /* 文字大小 */
      z-index: 999; /* 设置元素的堆叠顺序，确保它在其他元素上层显示 */
      position: relative;
      
    }
    .textLogo{
        position: fixed; /* 使用固定定位 */
      top: 2%; /* 与顶部的距离 */
      left: 85px;
      color: #14d8d8; /* 文字颜色 */
      font-size: 40px; /* 文字大小 */
      z-index: 999; /* 设置元素的堆叠顺序，确保它在其他元素上层显示 */
    
    
      
    }
    .glowing-text {
      font-size: 34px; /* 设置文字大小 */
      text-shadow: 0 0 10px rgb(0, 213, 228); /* 添加发光效果，可以根据需要调整发光效果的大小和颜色 */
      color: #03dac8; /* 设置文字颜色 */
    }
    .picture{
        height: 75px;
        width: 75px;
        z-index: 9999; /* 设置元素的堆叠顺序，确保它在其他元素上层显示 */
        position: fixed; /* 使用固定定位 */
      top: 2%; /* 与顶部的距离 */
      left: 10px;
    }
    .chartCircle{
        z-index: 1000; /* 设置元素的堆叠顺序，确保它在其他元素上层显示 */
        position: fixed; /* 使用固定定位 */
      top: 20%; /* 与顶部的距离 */
      left: 8.5%;
    }
    .square {
        width: 0.5%;
        height: 2.2%;
        /* 设置背景颜色 */
    }
    
    /* 设置箱子的宽度、高度和边框样式 */
    
    
    </style>
    